import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
const includes = ['6 Teaching Volumes — 300 pages', '4 Professional Bonuses — 120 pages', '420+ pages of ready-to-use A1–B1 content', 'Instant access in PDF format', 'Available for instant download worldwide', 'One-time payment, no subscription', 'Automatic conversion to your local currency', '14-day money-back guarantee'];
export function ClosingBlock() {
  return <section id="closing" className="w-full scroll-mt-20 bg-navy px-5 py-14 sm:py-24" data-id="element-47" data-mp="1w01d8w7z7jx5">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-48" data-mp="1s0aqd3lklnxw">
        <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-49" data-mp="1d305x4qy97q1">
          Your Lessons Are Ready. Your Week Is Organized. Now You Can Focus on Teaching.
        </h2>
        <p className="mt-4 text-lg font-medium text-gold sm:text-xl" data-id="element-50" data-mp="3skelv2uobj9m">The ESL Survival Vault™</p>
        <ul className="mt-8 grid w-full max-w-md gap-3 text-left" data-id="element-51" data-mp="3dw1l7skn5c8s">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-52" data-mp="3iveiz8d1w3q5">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-53" data-mp="aejnidyl1lm3">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-54" data-mp="fdwaqztd8up7" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-55" data-mp="gvi8u3covpo">{item}</span>
            </li>)}
        </ul>
        <div className="mt-10 flex flex-col items-center" data-id="element-56" data-mp="5e5fgvwzebo2">
          <span className="text-lg font-medium text-white/40 line-through sm:text-xl" data-id="element-57" data-mp="2l6umash9ykn0">$350 USD</span>
          <span className="font-display text-[52px] font-bold leading-none text-gold sm:text-7xl" data-id="element-58" data-mp="2q5fp8znwvif5">
            $27 USD
          </span>
        </div>
        <a href={CHECKOUT_URL} className="cta-button mt-9 flex min-h-[58px] w-full max-w-md items-center justify-center rounded-[10px] bg-gold px-6 py-4 text-base font-extrabold text-navy shadow-lg shadow-gold/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-lg" data-id="element-59" data-mp="wmfdec8gci3y">
          YES, I WANT THE COMPLETE SYSTEM
        </a>
        <p className="mt-3 text-xs text-white/60" data-id="element-60" data-mp="d0aoqj0wb947">
          Instant access · One-time payment · Automatic currency conversion · 14-day guarantee
        </p>
      </motion.div>
    </section>;
}